import React from 'react';

function CancelIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.82812"
        y="5.17188"
        width="3"
        height="11"
        rx="1"
        transform="rotate(-45 2.82812 5.17188)"
      />
      <rect
        x="10.6055"
        y="3.05078"
        width="3"
        height="11"
        rx="1"
        transform="rotate(45 10.6055 3.05078)"
      />
    </svg>
  );
}

export default CancelIcon;
